import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import customersModule from './modules/customers'
import contractsModule from './modules/contracts'
import financesModule from './modules/finances'
import metersModule from './modules/meters'
import transferModule from './modules/transfer'
import allocationsModule from './modules/allocations'
import allocationDialogModule from './modules/allocationDialog'
import readingsModule from './modules/readings'


Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  // modules: ['customers'],
  reducer: state => ({
    customers: state.customers,
    permissionAreas: state.permissionAreas,
    onHoldRules: state.onHoldRules,
  })
})

export const store = new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    id: null,
    results: null,
    serviceBundleResults: null,
    permissionAreas: null,
    onHoldRules: null,
    completeServiceBundle: null
  },
  mutations: {
    updateCompleteServiceBundle(state, payload) {
      state.completeServiceBundle = payload
    },
    setId(state, id) {
      state.ledger = null
      state.id = id
    },
    updateResults(state, results) {
      state.results = results
    },
    updateServiceBundleResults(state, payload) {
      // if (payload.Index != 'Transfer' && payload.Index != 'Export') {
      //  return state.contracts.contractIndex[payload.Index].results = payload.Results
      // }
      return state.serviceBundleResults = payload.Results
    },
    resetResults(state) {
      state.results = null
    },
    resetServiceBundleResults(state) {
      state.serviceBundleResults = null
    },
    updatePermissionAreas(state, permissionAreas) {
      state.permissionAreas = permissionAreas
    },
    updateOnHoldRules(state, onHoldRules) {
      state.onHoldRules = onHoldRules
    }
  },
  actions: {
    async tokenRefresh({ dispatch }) {
      await Vue.prototype.$auth.backgroundLogin()
      dispatch('autoRefresh')
    },
    autoRefresh({ dispatch }) {
      var now = Date.now()
      var exp = (JSON.parse(window.localStorage.getItem('Auth.decodedToken')).exp * 1000) - 120000
      var timeUntilRefresh = exp - now
      // console.log("refresh in " + timeUntilRefresh + " milliseconds.")s
      setTimeout(() => {
        dispatch('tokenRefresh')
      }, timeUntilRefresh);
    },
    search({ commit }, criteria) {
      Vue.prototype.$http.
        // get("https://" + Vue.config.honeycomb.contractbot.domain + "/api/v1/searches/?criteria=" +  criteria, {
        get("https://" + Vue.config.honeycomb.contractbot.domain + "/api/v1/AzureSearches/?criteria=" + criteria, {
          withCredentials: true
        })
        .then(response => {
          commit('updateResults', response.data.value);
        });
    },
    serviceBundleSearch({ commit }, payload) {
      Vue.prototype.$http.
        get("https://" + Vue.config.honeycomb.queenbee.domain + "/api/v1/ServiceBundle/Search/?criteria=" + payload.Criteria, {
          withCredentials: true
        })
        .then(response => {
          let results = [];
          if (response.data && response.data.Results) {
            results = response.data.Results.map(bundle => ({ Document: bundle }));
          }
          commit('updateServiceBundleResults', { Results: results, Index: payload.Index });
        })
        .catch(() => {
          commit('updateServiceBundleResults', { Results: [], Index: payload.Index });
        });
    },
    getPermissionAreas({ commit }) {
      Vue.prototype.$http.
        get("https://" + Vue.config.honeycomb.auth.domain + "/api/v1/areas", {
          withCredentials: true
        })
        .then(response => {
          commit('updatePermissionAreas', response.data)
        });
    },
    getOnHoldRules({ commit }) {
      return Vue.prototype.$http.get(
        `https://${Vue.config.honeycomb.billbot.domain}/api/v1/OnHold/OnHoldRulesConfiguration`,
        { withCredentials: true }
      ).then(response => {
        commit('updateOnHoldRules', response.data);
      });
    },

    async submitOnHoldRules({ commit }, dto) {
      Vue.prototype.$http.post(
        "https://" + Vue.config.honeycomb.billbot.domain + "/api/v1/OnHold/OnHoldRulesConfiguration",
        dto,
        { withCredentials: true }
      ).then(response => {
        commit('updateOnHoldRules', response.data)
      })
    },
    async getCompleteServiceBundle({ commit }, id) {
      Vue.prototype.$http.get(
        "https://" + Vue.config.honeycomb.queenbee.domain + "/api/v1/ServiceBundle/" + id + "/complete",
        { withCredentials: true }
      ).then(response => {
        commit('updateCompleteServiceBundle', response.data)
      })
    }

    //------ Permissions Notes ------//
    // OTS|LDURC
    // 100|10111 <-- ONE BYTE, WITH EACH BIT ACTING AS A FLAG

    // Key:
    // C - CREATE = 1
    // R - READ = 2
    // U - UPDATE = 4
    // D - DELETE = 8
    // L - LIST = 16
    // ----------------
    // S - SELF = 32
    // T - TEAM = 64 
    // O - ORGANISATION = 128
  },
  getters: {

  },
  modules: {
    customers: customersModule,
    contracts: contractsModule,
    finances: financesModule,
    meters: metersModule,
    transfer: transferModule,
    allocations: allocationsModule,    // NOT in VuexPersist reducer — volatile session data
    allocationDialog: allocationDialogModule,  // NOT in VuexPersist reducer — volatile session data
    readings: readingsModule  // presentation logic for meter readings (filter state read-through from meters)
  }
});
